export default {
  screens: [
    {
      type: 'intro',
      title: 'CHAUMET',
      content:
        '1812年，创始人马利-艾虔·尼铎之子——弗朗索瓦-勒尼奥·尼铎将CHAUMET迁入芳登广场15号的格拉蒙公馆，成为第一位落户于此的高级珠宝商。',
      idYt: 'Ksm_iOCcZVE',
      videoCover: 'world/home/video.jpg',
      desktop: {
        cover: 'world/home/cover-1.jpg'
      },
      mobile: {
        cover: 'world/home/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '60%',
          bottom: '-30%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'perspective',
      leftImg: 'world/home/perspectiveLeft.jpg',
      middleImg: 'world/home/perspectiveMiddle.jpg',
      content:
        '1907年，品牌第四代传人约瑟夫·尚美将CHAUMET迁至芳登广场12号并沿袭至今。芳登广场12号是一个身份复杂的复合体，它是：文化历史保护建筑、CHAUMET博物馆及档案馆、设计工作室与高级珠宝手工坊以及高级精品店与婚尚空间。',
      cover: 'world/home/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/cover-3.jpg'
      },
      mobile: {
        middleImg: 'world/home/shadowMiddle.jpg',
        leftImg: 'world/home/shadowLeft.jpg',
        cover: 'world/home/mobile-cover-3.jpg',
        coverStyle: {
          width: '79%',
          bottom: '-27%',
          right: '-4%',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '善于创新的设计师、品牌创始人马利-艾虔·尼铎 (Marie-Etienne Nitot)将精湛技艺传给了继承者们。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cn/worlds/home.js